import { render } from "./MasterCardIcon.vue?vue&type=template&id=ab0df8c8"
import script from "./MasterCardIcon.vue?vue&type=script&lang=js"
export * from "./MasterCardIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__